<template>
	<div>
		<div class="flex w-full justify-center py-2 md:py-8">
			<div class="w-full max-w-6xl flex justify-between flex-row p-4 grid grid-cols-1 md:grid-cols-2">
				<div class="mb-4 md:mb-0">
					<img src="/images/baby-parent-hands0129.jpg" alt="Image" class="w-full h-full md:max-w-xl object-cover duration-300 group-hover:scale-110 rounded-lg" />
				</div>
				<div class="md:items-end w-full flex flex-col gap-y-4 md:pl-8">
					<div class="text-sm sm:text-base font-normal md:font-light text-ihh-slate-gray text-start max-w-sm leading-relaxed sm:leading-loose">
						<div class="text-2xl md:text-ihh-h2 text-ihh-midnight-gray font-semibold tracking-wide pb-2">Our Mission</div>
						At In His Hands we are your source for all things birth. Whether it be for your birth or those you are serving, we provide the very best products with
						the highest level of service to help make the birth experience the very best it can be.
					</div>
					<div class="text-sm sm:text-base font-normal md:font-light text-ihh-slate-gray text-start max-w-sm leading-relaxed sm:leading-loose">
						In His Hands is a Christian company. Our name points to our faith, that God holds all things In His Hands including all the babies He creates and
						brings into the world.
					</div>
				</div>
			</div>
		</div>

		<div class="flex w-full justify-center py-2 md:py-8">
			<div class="w-full max-w-6xl flex justify-between flex-row p-4 grid grid-cols-1 md:grid-cols-2">
				<div class="flex flex-col gap-y-4 md:pr-8 order-2 md:order-1">
					<div class="text-2xl md:text-ihh-h2 text-ihh-midnight-gray font-semibold tracking-wide">Who We Are</div>
					<div class="text-sm sm:text-base font-normal md:font-light text-ihh-slate-gray text-start max-w-sm leading-relaxed sm:leading-loose">
						Since 1999 In His Hands has been owned by the <span class="font-semibold">Youngblood family</span> in central Texas. By the grace of God and with the
						help of many special friends we have grown to serve the birth community all across the U.S. and worldwide. As the natural birth market continues to
						grow we strive to be the best go-to source for <span class="font-semibold">all things birth</span> for expectant parents, midwives and birth centers.
					</div>
					<div class="mt-4">
						<a
							href="/about-us"
							class="flex w-full justify-center max-w-40 text-center text-sm text-ihh-midnight-gray font-semibold border-2 border-ihh-salmon px-6 py-3 rounded-lg hover:bg-ihh-salmon transition-all whitespace-nowrap"
							>Our full story</a
						>
					</div>
				</div>
				<div class="order-1 md:order-2 mb-4 md:mb-0 lg:ml-24 xl:ml-44">
					<!-- <img src="/images/youngblood-family0129.jpg" class="flex w-full max-w-xl rounded-lg"/> -->
					<img src="/images/christin_mission_wwa.jpg" alt="Image" class="w-auto h-[36rem] md:max-w-xl object-cover duration-300 group-hover:scale-110 rounded-lg" />
				</div>
			</div>
		</div>
	</div>
</template>
